import { FC } from 'react'
import styles from './phone-number.module.scss'
import Button from '../Button'
import PhoneIcon from '@/components/icons/PhoneIcon'

type PhoneNumberProps = {}

const PhoneNumber: FC<PhoneNumberProps> = ({}) => {
  return (
    <Button
      className={styles.phone}
      as="a"
      href="tel:88007775525"
      icon={<PhoneIcon />}
      iconClassName={styles.icon}
    >
      8&nbsp;(800)&nbsp;777&#8209;55&#8209;25
    </Button>
  )
}

export default PhoneNumber
